module.exports = __webpack_public_path__ + "src/assets/img/13.46b2ffb2.svg";